export default {
  conversationId: null,
  messages: [],
  loading: false,
  lastSearchQuery: null,
  refinements: [],
  searchRefinements: [],
  products: [],
}